import { useSelector } from "react-redux";
import { useInfiniteQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const PAGE_SIZE = 20;

export const useGetChannelMessages = (channelId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useInfiniteQuery({
    queryKey: ["chatGroup", tenantVal, channelId],
    queryFn: async ({ pageParam = 0 }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/chat/group/${channelId}/messages`,
        { params: { page: pageParam, size: PAGE_SIZE } }
      );

      const data = response.data;

      // Handle paginated response shape
      if (data && typeof data === "object" && Array.isArray(data.messages)) {
        return data;
      }

      // Fallback: if backend returns a plain array (no pagination params sent)
      return {
        messages: Array.isArray(data) ? data : [],
        page: 0,
        size: PAGE_SIZE,
        totalElements: Array.isArray(data) ? data.length : 0,
        totalPages: 1,
        hasNext: false,
        hasPrevious: false,
      };
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.hasNext) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    refetchInterval: 30000,
    enabled: !!tenantVal && !!channelId,
    meta: { errorMessage: "Error fetching channel messages" },
  });
};
